import { SimulatorForm } from "components/wealth/simulator-form";
import LandingSection from "components/common/landing-section";
import { useAtomValue } from "lib/global-context";
import useSendHeightToParent from "hooks/useSendHeightToParent";
import { currentStepAtom } from "lib/atoms";
import schema from "data/schema/wealth-accumulation.json";
import PageContainer from "components/common/page-container";

export default function Home() {
  useSendHeightToParent();

  const setCurrentStep = useAtomValue(currentStepAtom);

  const { title, description, ctaButtonText, imageSrc } =
    schema.questionnaire.displayConfiguration;
  const questions = schema.questionnaire.questions;

  return (
    <PageContainer page="wealth">
      {setCurrentStep === 0 ? (
        <LandingSection
          page="wealth"
          imageSrc={imageSrc}
          headline={title}
          body={description}
          buttonText={ctaButtonText}
        />
      ) : (
        <SimulatorForm questions={questions} />
      )}
    </PageContainer>
  );
}
